import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UserService } from '../../api/services/user.service';
import { Report } from '../../api/models/report';
import { AuthService } from '../../api/services/auth.service';

@Component({
  selector: 'app-report-create',
  templateUrl: './report-create.component.html',
  styleUrls: ['./report-create.component.scss']
})
export class ReportCreateComponent implements OnInit {

  report = new Report();

  hasFile = false;

  action: string;

  reportTypes = ['File', 'Link'];

  selectedType = 'File';

  @Input() organizationId: string;

  constructor(public activeModal: NgbActiveModal,
              private userService: UserService,
              private authService: AuthService
  ) { }

  setType(type: string) {
    this.selectedType = type;
    if (type === 'File') {
      this.report.link = null;
    } else {
      this.report.fileId = null;
    }
  }

  onReportFileUploaded(id: string) {
    this.hasFile = true;
    this.report.fileId = id;
  }

  deleteFile() {
    this.hasFile = false;
    this.report.fileId = '';
  }

  save() {
    this.userService.createReport(this.report).subscribe(() => {
      this.activeModal.close();
    });
  }

  reportIsValid() {
    return this.report.name && ( this.report.fileId || this.report.link);
  }

  ngOnInit() {
   this.report.organizationId = this.organizationId;
  }

}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/report-create/report-create.component.ts